import { render, staticRenderFns } from "./SettingsAppearancePanel.vue?vue&type=template&id=54a2ec62"
import script from "./SettingsAppearancePanel.vue?vue&type=script&lang=ts"
export * from "./SettingsAppearancePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports